import { render } from "./PaymentMethodsPanel.vue?vue&type=template&id=3098c9e1&scoped=true"
import script from "./PaymentMethodsPanel.vue?vue&type=script&lang=ts"
export * from "./PaymentMethodsPanel.vue?vue&type=script&lang=ts"

import "./PaymentMethodsPanel.vue?vue&type=style&index=0&id=3098c9e1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3098c9e1"

export default script